// src/components/TurnstileLoader.tsx
import { useEffect } from "react";

export default function TurnstileLoader() {
    useEffect(() => {
        if (document.getElementById("cf-turnstile-script")) return;

        const script = document.createElement("script");
        script.id = "cf-turnstile-script";
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);
    }, []);

    return null;
}
